<template>

  <div id="app">

    <alert :message.sync="message" :alertType.sync="alertType" v-if="message"></alert>
    
    <div v-if="isLoading" class="loader w-100 h-100 d-flex justify-content-center align-items-center position-fixed">
      <img width="100" height="100" src="/static/img/preloader.gif" alt="Loading...">
    </div>
    <!-- <AppSpinner /> -->
    <Header :user="user" @logout="logout" v-if="shouldShowHeader"/>
    <Courses :courses="courses" :v-if="!isLoading" v-if='this.$route.name !== "registration" && this.$route.name !== "login" && this.$route.path !== "/" && this.$route.name !== "recovery"'/>
    <main class="main" v-if='this.$route.path !== "/" && this.$route.name !== "registration" && this.$route.name !== "login" && this.$route.name !== "payment-link" && this.$route.name !== "invoices" && this.$route.name !== "cash" && this.$route.name !== "api" && this.$route.name !== "pay-link" && this.$route.name !== "cash-exchange" && this.$route.name !== "contacts"'>
      <div class="container">
        <div class='row md-mb-5'>
          <div class="col-3 d-none d-lg-block">
            <nav class="aside_nav rounded border_darkgreen" style="height: 582px">
              <ul class="nav flex-column h-100">
                <li class="nav-item" v-for="item in asideMenuDesc" :key="item.id">
                  <router-link
                    class="nav-link" :class="item.title == 'Мои активы' ? 'd-flex gap-2 align-items-center' : ''"
                    :to="{ name: item.name }"
                    exact-active-class="active">
                    {{ item.title }}
                    <span v-if="item.title == 'Мои активы' && user?.active_operations?.length > 0" class="badge rounded-circle bg-warning text-black d-flex justify-content-center align-items-center" style="width:17px; height:17px;font-size:10px;">{{user?.active_operations?.length}}</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <!-- <router-link to="/cash-exchange" class="nav-link" exact-active-class="active">
                    Наличные
                  </router-link> -->
                  <router-link to="/pay-link" class="nav-link" exact-active-class="active">
                    Оплата по ссылке
                  </router-link>
                </li>
                <a target="_blank" href="https://t.me/valutix" class="telegram_link bg_lightgreen ps-3 pe-4 py-2 position-relative rounded text-white mt-auto w-75">
                  <span class="fs-7 fw-bold lh-sm d-block" style="max-width: 150px">Подписывайся на наш телеграм</span>
                  <img width="121" height="121" src="/img/t.svg" alt="Telegram" class="position-absolute start-100 top-50 translate-middle">
                </a>
              </ul>
            </nav>
          </div>
          <!-- <div class="col-12 col-lg-1 d-none d-lg-block"></div>  -->
            <div class='col col-lg-9'>
              <router-view
                :v-if="!isLoading"
                @verify="verify"
                @del_wallet="delete_wallet"
                @login_user="login_user"
                :courses="courses"
                :user="user"
                :cards="cards"
                :wallets="wallets"
                :cards_count="cardsCount"
                :wallets_count="walletsCount"
                :user_load="onLoadUser"
                :balances="balances"
                :cryptos="crypto"
                :for_buy="forBuyCrypto"
                :for_deposit="forDeposit"
                :history="history"
                :invoice="invoice"
                :currencies="currencies"
                :courses_list="courses"
                :crypto="crypto"
                :myMethods="myMethods"
                />
            </div>
        </div>
      </div>
    </main>

    <router-view
      v-if='!isLoading && (this.$route.name == "registration" || this.$route.name === "login" || this.$route.name === "recovery" || this.$route.path == "/" || this.$route.name == "payment-link" || this.$route.name == "invoices" || this.$route.name == "cash" || this.$route.name == "api" || this.$route.name == "pay-link" || this.$route.name == "cash-exchange" || this.$route.name == "contacts")'
      @verify="verify"
      @del_wallet="delete_wallet"
      @login_user="login_user"
      :courses="courses"
      :user="user"
      :cards="cards"
      :wallets="wallets"
      :cards_count="cardsCount"
      :wallets_count="walletsCount"
      :user_load="onLoadUser"
      :balances="balances"
      :cryptos="crypto"
      :for_buy="forBuyCrypto"
      :for_deposit="forDeposit"
      :history="history"
      :invoice="invoice"
      :currencies="currencies"
      :courses_list="courses"
      :crypto="crypto"
      :myMethods="myMethods"
    />
    <Footer v-if="this.$route.name !== 'registration' && this.$route.name !== 'recovery' && this.$route.name !== 'login'"/>
    <section class="account_menu bg_green" v-if='this.$route.name !== "registration" && this.$route.name !== "login" && this.$route.name !== "recovery" && !isLoading && user !== null && this.$route.name !== "payment-link" && this.$route.name !== "invoices" && this.$route.name !== "cash" && this.$route.name !== "api" && this.$route.name !== "contacts" && this.$route.path !== "/"'>
      <div class="container">
        <nav class='mobile-bottom-menu'>
          <a href="#" @click.prevent="toggleCollapse" :class="{ 'router-link-active': toggled }">
            <div class="image_block">
              <img :src="`/img/mobile-menu/concierge.svg`">
            </div>
            <span>Консьерж</span>
          </a>
          <router-link v-for="item in asideMenu" :key="item.id"
            :to="{ name: item.name }"
            exact-active-class="active">
            <div class="image_block">
              <img :src="`/img/mobile-menu/${item.name}.svg`">
            </div>
            <span>{{ item.title }}</span>
          </router-link>
        </nav>
      </div>
      <div
      id="conciergeCollapse"
      class="collapse position-fixed w-100 text-white"
      style="bottom: 82px; left: 0; z-index: 1020; border-radius: 5px 5px 0 0"
      @click="toggled = !toggled;"
    >
    <div class="container">
      <div class="py-3 rounded-top-4 fs-6 w-100">
        <span type="button" data-bs-toggle="collapse" :data-bs-target="'#conciergeCollapse'" aria-expanded="false"
        :aria-controls="'conciergeCollapse'" class="ms-auto rounded d-block bg-white" style="width:30px; height:3px;"></span>
        <!-- <router-link @click.native="closeCollapse" to="/cash-exchange" class="d-block text-white text-decoration-none mb-1">
          Наличные
        </router-link> -->
        <router-link @click.native="closeCollapse" to="/pay-link" class="d-block text-white text-decoration-none">
          Оплата по ссылке
        </router-link>
      </div>
    </div>
    </div>
    </section>
    <EnterModal @login_user="login_user" />
    <RegistrationModal @login_user="login_user" />
    <Supportmodal/>

  </div>
</template>

<script>
import "./css/main.css";
import AppSpinner from "@/components/General/AppSpinner.vue";
import Courses from "@/components/CoursesComponent.vue";
import Header from "@/components/General/HeaderComponent.vue";
import Footer from "@/components/General/FooterComponent.vue";
import RegistrationModal from "@/components/Index/RegistrationComponent.vue";
import EnterModal from "@/components/Index//EnterComponent.vue";
import Supportmodal from '@/components/Support-modal.vue'
import Alert from "@/components/Alert.vue";
import {eventBus} from "@/eventBus";

export default {
  name: "App",
  components: {
    AppSpinner,
    Courses,
    Header,
    Footer,
    RegistrationModal,
    EnterModal,
    Supportmodal,
    Alert
  },

  data: () => ({
    isLoading: true,
    showHeader: false,
    user: [],
    history: [],
    page: 1,
    forBuyCrypto: {
      transaction_id: 0,
      crypto_id: 0,
      amount: 0,
      status: "",
    },
    forDeposit: {
      deposit_id: 0,
      crypto_id: 0,
      amount: 0,
      status: "",
    },
    historyCount: 0,
    courses: [],
    cards: [],
    balances: [],
    crypto: [],
    invoice: "",
    cardsCount: 0,
    wallets: [],
    walletsCount: 0,
    onLoadCards: false,
    onLoadWallets: false,
    onLoadUser: false,
    onLoadCourses: false,
    onLoadHistory: false,
    message: false,
    alertType: false,
    currencies: [],
    myMethods : [],
    isMobile: window.innerWidth < 992,
    asideMenu: [
      { id: 1, name: "converting", title: "Конвертация" },
      { id: 2, name: "actives", title: "Мои активы"},
      { id: 3, name: "history", title: "История" },
      { id: 4, name: "profile", title: "Профиль" },
    ],
    asideMenuDesc: [
      { id: 1, name: "actives", title: "Мои активы"},
      { id: 2, name: "converting", title: "Конвертация" },
      { id: 3, name: "history", title: "История" },
      { id: 4, name: "profile", title: "Профиль" },
    ],
    toggled: false,
  }),
  computed: {
    shouldShowHeader() {
      if (this.$route.path === '/') {
        return this.showHeader || this.isMobile;
      }
      return true;
    }
  },
  methods: {
    initPopover() {
      this.$nextTick(() => {
        const tooltipElements = [].slice.call(this.$el.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipElements.forEach(el => new bootstrap.Tooltip(el, { container: 'body' }));
      });
    },
    toggleCollapse() {
      this.toggled = !this.toggled;
      const el = document.getElementById('conciergeCollapse')
      const collapse = bootstrap.Collapse.getOrCreateInstance(el)
    collapse.toggle()
    },
    closeCollapse() {
      const el = document.getElementById('conciergeCollapse')
      const collapse = bootstrap.Collapse.getOrCreateInstance(el)
      collapse.hide()
    },
    handleScroll() {
      if (this.$route.path === '/') {
        this.showHeader = window.scrollY > 77;
      }
    },
    handleResize() {
    this.isMobile = window.innerWidth < 992;
  },
    login_user() {
      this.getInfo();
      this.$router.push("/actives");
    },
    logout() {
      if(this.user) this.user = null;
      localStorage.clear();
      this.$router.push("/");
      document.body.style.overflow = 'auto';
      const CoursesBlock = document.getElementById('app');
      if (CoursesBlock) {
        CoursesBlock.scrollIntoView({ behavior: 'smooth' });
      }
},
    async getInfo() {
      this.isLoading = true;
      document.body.classList.add('no_scroll');
      this.$user_ID.value = localStorage.getItem('user_ID');
      this.$status_id.value = localStorage.getItem('status_id');
      this.$user_token.value = localStorage.getItem('user_token');
      // await this.getHistory(this.page);
      await this.fetchMethods();
      await this.getCourses();
      await this.getUser();
      eventBus.$emit('turnOnPusher', true);
      document.body.classList.remove('no_scroll');
      this.isLoading = false;
    },

    //getUser
    async getUser() {
      if (localStorage.getItem('user_ID')) {
        this.onLoadUser = true;
        await axios
          .get(this.$api_address + "/users/token", {
            headers: {
              "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
            },
          })
          .then((response) => {
            this.user = response.data.data;
            this.$status_id.value = this.user.status.id;
            this.balances = response.data.data.balances;
            this.crypto = this.balances?.filter((c) => c.currency?.currency_type?.name === 'Cryptocurrency').sort((a, b) => a.currency.id - b.currency.id);
            this.cards = response.data.data.cards.sort((b, a) => a.id - b.id);
            this.cardsCount = this.cards.length;
            this.wallets = response.data.data.wallets.sort((b, a) => a.id - b.id);
            this.walletsCount = this.wallets.length;
          })
          .catch((error) => {
            console.error("Error fetching user:", error);
          }).finally(() => {
            this.onLoadUser = false;
          })
      }
    },

    //getMethods
    async fetchMethods() {
        try {
            const response = await axios.get(`${this.$api_address}/payment_methods/service/1`, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
                }
            });

            const actualData = response.data;
            this.myMethods = actualData.data
                .filter(item => item.active?.find(c => c.service?.name === "Valutix")?.active == 1)
                .sort((a, b) => a.id - b.id);

        } catch (error) {
            if (error.response?.status !== 401) {
                eventBus.$emit('errorBus', 'Не удалось получить методы');
            }
            else {
                eventBus.$emit('logout');
            }
        }
    },

    //getCourses
    async getCourses() {
      this.onLoadCourses = true;
      await axios
        .get(this.$api_address + "/courses/service/1")
        .then((response) => {
            this.courses = response.data.data.sort((a, b) => a.id - b.id);;
        });
        this.onLoadCourses = false;
    },

    updCourses() {
      this.getCourses();
    },
 
  delete_wallet(index) {
    this.onLoadWallets = true;
    axios
    .delete(this.$api_address + "/wallets/"+this.wallets[index].id, {
      headers: {
          "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
      },
      validateStatus: function (status) {
        return status < 500;
      },
    })
    .then((response) => {
      this.wallets.splice(index, 1);
      this.walletsCount--;
      this.onLoadWallets = false;
    })
    .catch((error) => {
      console.error(error);
      this.onLoadWallets = false;
    });
  },
    verify() {
      this.getUser();
    },
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler(newPath) {
        if (newPath === '/') {
          window.addEventListener('scroll', this.handleScroll);
          this.showHeader = false; // Сбрасываем состояние при переходе на главную
        } else {
          window.removeEventListener('scroll', this.handleScroll);
          this.showHeader = true;
        }
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },

  updated() {
    this.initPopover();
  },

  //created
  created() {
    window.addEventListener("resize", this.handleResize);
    this.$watch(
      () => this.$user_ID.value,
      (newValue) => {
        localStorage.setItem("user_ID", newValue);
      },
      () => this.$status_id.value,
      (newValue) => {
        localStorage.setItem("status_id", newValue);
      },
      () => this.$user_token.value,
      (newValue) => {
        localStorage.setItem("user_token", newValue);
      },
      () => this.$session_id.value,
      (newValue) => {
        localStorage.setItem("session_id", newValue);
      },

    );

    if(!localStorage.getItem('user_token') && this.$route.name !== 'invoice' && this.$route.name !== 'login' && this.$route.name !== 'registration' && this.$route.name !== 'recovery'
    && this.$route.name !== 'cash' && this.$route.name !== 'api' && this.$route.name !== 'invoices' && this.$route.name !== 'payment-link'  && this.$route.name !== 'contacts' && this.$route.name !== 'terms_of_use' && this.$route.name !== 'aml-kyc' && this.$route.name !== 'pay-link' && this.$route.name !== 'privacy-police' && this.$route.name !== 'cash-exchange') {
      this.logout();
    }

    if(localStorage.getItem('user_token')) {
      this.getInfo();
    } else {
      this.getCourses();
      setTimeout(() => {
        this.isLoading = false;
      }, 1500);
    }

    //Обновление баланса
    eventBus.$on("balanceUpdate", (data) => {
      if(data.userId == this.$user_ID.value) {
        this.getUser();
      }
    });

    eventBus.$on("logout", () => {
      this.logout();
    })

    eventBus.$on("coursesUpdate", () => {
      console.log('coursesUpdate');
      this.getCourses();
    });

    //Добавление карты
    eventBus.$on("add_card", (data) => {
      this.onLoadCards = true;
      this.cards.push(data);
      this.cards = this.cards.sort((b, a) => a.id - b.id);
      this.cardsCount++;
      this.onLoadCards = false;
    });

    //Добавление кошелька
    eventBus.$on("add_wallet", (data) => {
      this.onLoadWallets = true;
      this.wallets.push(data);
      this.wallets = this.wallets.sort((b, a) => a.id - b.id);
      this.walletsCount++;
      this.onLoadWallets = false;
    });

    eventBus.$on("userUpdate", (data) => {
      if(!this.user) return
      if(data.id == this.user?.id) {
        if(data.status?.id == 5) {
          this.logout();
          return;
        }
        if(data.status?.id && data.status?.title) {
            this.user.status.id = data.status.id;
            this.user.status.title = data.status.title;
        }
      }
    });

    //Удаление карты
    eventBus.$on("card_delete", (cardId) => {
      this.onLoadCards = true;
      axios.delete(this.$api_address + "/cards/"+cardId, {
        headers: {
              "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
          },
      validateStatus: function (status) {
        return status < 500; // Resolve only if the status code is less than 500
      }})
      .then((response) => {
        // Найти индекс карты с данным id в массиве cards
        const index = this.cards.findIndex((card) => card.id === cardId);
        if (index !== -1) {
          // Удалить карту из массива cards
          this.cards.splice(index, 1);
          this.cardsCount--;
        }
        this.onLoadCards = false;
      })
      .catch(function (error){
        if (error.response?.status !== 401) {
            eventBus.$emit('errorBus', 'Не удалось удалить карту');
        }
        else {
            eventBus.$emit('logout');
        }
      });

    });

    eventBus.$on('errorBus', (msg, type) => {
      this.message = msg;
      this.alertType = type;
    });

  },
//   mounted() {
//     this.$nextTick(() => {
//     const el = document.getElementById('conciergeCollapse');
//     if (!el) return;

//     el.addEventListener('show.bs.collapse', () => {
//       this.toggled = true;
//     });

//     el.addEventListener('hide.bs.collapse', () => {
//       this.toggled = false;
//     });
//   });
// },
};
</script>

<style>
.main {
  padding: 40px 0 57px;
}

.fs-7 {
  font-size: 13px;
}
@media (max-width:500px) {
  .fs-7 {
      font-size: 10px;
  }
}

.aside_nav {
  padding: 33px 0 40px 23px;
  max-height: 582px;
  background: url(@/assets/aside-gradient.png) no-repeat right bottom;
  background-size: cover;
}

.aside_nav .nav-item a {
  color: #FFF;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: transparent;
  box-shadow: none;
}
.aside_nav .nav-item a:hover {
  background-color: transparent;
}

.account_menu {
    position: sticky;
    bottom:0;
    display: none;
    z-index:99;
    -webkit-box-shadow: 0px -5px 15px -5px rgba(34, 60, 80, 0.6);
    -moz-box-shadow: 0px -5px 15px -5px rgba(34, 60, 80, 0.6);
    box-shadow: 0px -5px 15px -5px rgba(34, 60, 80, 0.6);
    overflow: hidden;
}
.account_menu .mobile-bottom-menu {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(5, 1fr);
  background-color: #35634F;
  padding: 12px 0;
}

.mobile-bottom-menu .image_block {
  width: 43px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
}

.account_menu .mobile-bottom-menu a {
    text-decoration: none;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 3px;
}

.account_menu .mobile-bottom-menu .router-link-active .image_block {
  /*transform: scale(1.1);*/
  background-color: #4AA485;
}

.account_menu .mobile-bottom-menu a span {
  display: block;
  font-size: 8px;
  color: white;
  text-align: center;
  font-weight: 400;
}

.account_menu .mobile-bottom-menu .router-link-active img {
  filter: brightness(0) saturate(100%) invert(100%);
}

.account_menu .mobile-bottom-menu .router-link-active svg path  {
  fill: #fff;
}

.account_menu .mobile-bottom-menu .router-link-active svg rect  {
  stroke: #4AA485;
}

#conciergeCollapse {
  background-image: url('/public/static/forConsiergeBg.png');
  background-position: top right;
  background-size: 100%;
  background-color: rgba(53, 99, 79, 1);
}

@media(max-width:1200px) {
  .aside_nav {
      padding: 33px 0 40px 12px;
  }
}

@media(max-width:991px) {
    .account_menu {
        display: block;
    }
}

.no_scroll {
  overflow: hidden;
}
.loader {
  background:rgb(0, 0, 0);
  z-index: 999999;
}
</style>
